<template>
  <checkbox-multi-select
    label="staff.choose_students_to_assign"
    :options="studentData"
    v-model="selected"
    trackBy="uuid"
    ref="multiSelectRef"
    displayField="full_name"
    :itemTemplate="itemTemplate"
    @filtering="$emit('filtering', $event.text)"
    @select="selectItem"
    @open="$emit('open')"
    @removed="removedItem"
  >
  </checkbox-multi-select>
</template>
<script>
import Vue from "vue";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";

const itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='username'>{{data.full_name}}</span> - <span class ='student-code'>{{data.student_code}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

export default {
  name: "student-select-component",
  components: { CheckboxMultiSelect },
  props: ["studentData"],
  data() {
    return {
      fields: { text: "full_name", value: "uuid" },
      itemTemplate: function(e) {
        return {
          template: itemVue
        };
      },
      classId: this.$route.params.id,
      selected: [],
      memorizedSelected: []
    };
  },
  methods: {
    getMemorizedSelected() {
      return this.memorizedSelected;
    },
    setDefaultSelections() {
      this.selected = [];
    },
    selectItem(event) {
      this.memorizedSelected.push(event.itemData);
    },
    removedItem(event) {
      const { itemData } = event;
      this.memorizedSelected = this.memorizedSelected.filter(
        item => item !== itemData.username
      );
    }
  },
  watch: {
    studentData: function() {
      // this.setDefaultSelect();
    },
    selected: function() {
      this.$emit("update-selected", this.selected);
    }
  }
};
</script>
